import { gql } from "@apollo/client";

// Fragment for `UserSummary`
export const USER_SUMMARY_FRAGMENT = gql`
  fragment UserSummaryFragment on UserSummary {
    id
    firstName
    lastName
    profilePictureUrl
    email
  }
`;

export const FAMILY_SUMMARY_FRAGMENT = gql`
  fragment FamilySummaryFragment on FamilySummary {
    id
    name
    children {
      name
      gender
    }
    parents {
      id
      email
      firstName
      lastName
      profilePictureUrl
    }
  }
`